export default __webpack_public_path__ + "static/media/newbanner.a6322bb7.png";